import * as angular from 'angular';
import { LoggedInUser } from '../custom';
import { AuthService } from 'app/_services/auth.service';

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name columnFilterService
     * @memberof app
     *
     * @description
     * Takes care of some column filter logic in an attempt to refactor the column filter.
     *
     * @author flzemke.btc
     */
    angular.module('app').service('columnFilterService', columnFilterService);

    function columnFilterService(
        $filter,
        COLUMN_FILTER,
        authService: AuthService
    ) {
        /**
         * Column filters that have preset suggestions that aren't retrieved from the server.
         *
         * @type {app.COLUMN_FILTER#COL[]}
         */
        var presetColumnFilters = [
            COLUMN_FILTER.COL.DIRECTION,
            COLUMN_FILTER.COL.PERIODTYPE,
            COLUMN_FILTER.COL.CAPACITY_CATEGORY,
            COLUMN_FILTER.COL.OFFER_STATE,
            COLUMN_FILTER.COL.PRODUCT_TYPE,
            COLUMN_FILTER.COL.ASSIGNMENT_STATE,
            COLUMN_FILTER.COL.PRIMARY_ACCESS,
            COLUMN_FILTER.COL.SECONDARY_ACCESS,
            COLUMN_FILTER.COL.PHASE_TYPES,
            COLUMN_FILTER.COL.RAW_PRODUCT_STATE
        ];

        /**
         * The preset suggestions for preset column filters.
         *
         * @type {{app.COLUMN_FILTER#COL: app.ColumnFilterDto[]}}
         */
        var presetSuggestionsForColumnFilter = {};
        presetSuggestionsForColumnFilter[COLUMN_FILTER.COL.DIRECTION] = [
            { value: 'ENTRY', label: 'Entry' },
            { value: 'EXIT', label: 'Exit' },
            { value: 'BUNDLE', label: 'Exit/Entry' }
        ];
        presetSuggestionsForColumnFilter[COLUMN_FILTER.COL.PERIODTYPE] = [
            { value: 'WITHINDAY', label: 'Within-day' },
            { value: 'DAY', label: 'Day' },
            { value: 'MONTH', label: 'Month' },
            { value: 'QUARTER', label: 'Quarter' },
            { value: 'YEAR', label: 'Year' }
        ];
        presetSuggestionsForColumnFilter[COLUMN_FILTER.COL.CAPACITY_CATEGORY] =
            [
                { value: 'FIRM', label: 'Firm' },
                { value: 'FZK', label: 'FZK' },
                { value: 'B_FZK', label: 'bFZK' },
                { value: 'B_FZK_1', label: 'bFZK1' },
                { value: 'B_FZK_C', label: 'bFZKc' },
                { value: 'DZK', label: 'DZK' },
                { value: 'BZK', label: 'BZK' },
                { value: 'BACKHAUL_CAPACITY', label: 'Backhaul capacity' },
                { value: 'BACKHAUL_LEVEL_1', label: 'Backhaul level 1' },
                { value: 'BACKHAUL_LEVEL_2', label: 'Backhaul level 2' },
                { value: 'BACKHAUL_LEVEL_N', label: 'Backhaul level n' },
                { value: 'FIRM_ADDITIONAL', label: 'Firm additional' },
                { value: 'INTERRUPTIBLE', label: 'Interruptible' },
                {
                    value: 'INTERRUPTIBLE_LEVEL_1',
                    label: 'Interruptible level 1'
                },
                {
                    value: 'INTERRUPTIBLE_LEVEL_2',
                    label: 'Interruptible level 2'
                },
                {
                    value: 'INTERRUPTIBLE_LEVEL_N',
                    label: 'Interruptible level n'
                },
                { value: 'U_BZK', label: 'uBZK' },
                { value: 'FZK_C', label: 'FZKc' },
                { value: 'FZK_INC', label: 'FZKinc' },
                { value: 'U_KC', label: 'UKc' },
                { value: 'DZK_1', label: 'DZK1' },
                { value: 'DZK_2', label: 'DZK2' },
                { value: 'DZK_3', label: 'DZK3' },
                { value: 'DZK_4', label: 'DZK4' },
                { value: 'DZK_5', label: 'DZK5' },
                { value: 'DZK_SH', label: 'DZK-SH' },
                { value: 'IUKCF_1', label: 'IUKCF1' },
                {
                    value: 'INCREMENTAL_OFFER_LEVEL_1',
                    label: 'Incremental Offer level 1'
                },
                {
                    value: 'INCREMENTAL_OFFER_LEVEL_2',
                    label: 'Incremental Offer level 2'
                },
                {
                    value: 'INCREMENTAL_OFFER_LEVEL_3',
                    label: 'Incremental Offer level 3'
                },
                {
                    value: 'INCREMENTAL_OFFER_LEVEL_4',
                    label: 'Incremental Offer level 4'
                },
                {
                    value: 'INCREMENTAL_OFFER_LEVEL_5',
                    label: 'Incremental Offer level 5'
                }
            ];
        presetSuggestionsForColumnFilter[COLUMN_FILTER.COL.PROCEDURE] = [
            { value: 'CFO', label: 'CFO' },
            { value: 'FCFS', label: 'FCFS' },
            { value: 'OTC', label: 'OTC' }
        ];
        presetSuggestionsForColumnFilter[COLUMN_FILTER.COL.ASSIGNMENT_STATE] = [
            { value: 'APPROVED', label: 'Approved' },
            { value: 'NOT_APPROVED', label: 'Waiting for approval' },
            { value: 'PENDING', label: 'Temporarily disabled' }
        ];
        presetSuggestionsForColumnFilter[COLUMN_FILTER.COL.PRIMARY_ACCESS] = [
            { value: true, label: 'Approved' },
            { value: false, label: 'Not approved' }
        ];
        presetSuggestionsForColumnFilter[COLUMN_FILTER.COL.SECONDARY_ACCESS] = [
            { value: true, label: 'Approved' },
            { value: false, label: 'Not approved' }
        ];
        presetSuggestionsForColumnFilter[COLUMN_FILTER.COL.OFFER_STATE] = [
            { value: 'DRAFT', label: 'Draft' },
            { value: 'PUBLISHED', label: 'Published' },
            { value: 'OPEN', label: 'Open' },
            { value: 'FINISHED', label: 'Finished' }
        ].filter((state) => {
            let loggedInUser: LoggedInUser = authService.getLoggedInUser();

            if (loggedInUser !== null && loggedInUser.role === 'SSO_ADMIN') {
                return true;
            }

            return (
                (loggedInUser === null ||
                    loggedInUser.role === 'SHIPPER_USER' ||
                    loggedInUser.role === 'SHIPPER_ADMIN') &&
                ['DRAFT'].indexOf(state.value) === -1
            );
        });
        presetSuggestionsForColumnFilter[COLUMN_FILTER.COL.PRODUCT_TYPE] = [
            { value: 'SBU', label: 'SBU' },
            { value: 'STORAGE_VOLUME', label: 'Storage volume' },
            { value: 'INJECTION_CAPACITY', label: 'Injection capacity' },
            { value: 'WITHDRAWAL_CAPACITY', label: 'Withdrawal capacity' }
        ];
        presetSuggestionsForColumnFilter[COLUMN_FILTER.COL.PHASE_TYPES] = [
            { value: 'FINISHED', label: 'Finished' },
            { value: 'CANCELLED', label: 'Cancelled' },
            { value: 'UNSUCCESSFUL', label: 'Unsuccessful' },
            { value: 'TERMINATED', label: 'Terminated' }
        ].filter((state) => {
            let loggedInUser: LoggedInUser = authService.getLoggedInUser();

            if (loggedInUser != null && loggedInUser.role === 'TSO_USER') {
                return true;
            }

            return (
                (loggedInUser === null ||
                    loggedInUser.role === 'SHIPPER_USER' ||
                    loggedInUser.role === 'SHIPPER_ADMIN') &&
                ['TERMINATED'].indexOf(state.value) === -1
            );
        });
        presetSuggestionsForColumnFilter[COLUMN_FILTER.COL.RAW_PRODUCT_STATE] =
            [
                { value: 'UPLOADED', label: 'Uploaded' },
                { value: 'SUBMITTED', label: 'Submitted' },
                { value: 'FINISHED', label: 'Finished' },
                { value: 'CANCELLED', label: 'Cancelled' }
            ];

        return {
            filterSelectedSuggestions: filterSelectedSuggestions,
            hasBeenSelectedInThePast: hasBeenSelectedInThePast,
            addSelectedFlags: addSelectedFlags,
            getPresetSuggestions: getPresetSuggestions,
            getPresetSuggestionsForCapacityCategory:
                getPresetSuggestionsForCapacityCategory,
            getPresetSuggestionsForDirection: getPresetSuggestionsForDirection,
            getPresetSuggestionsForProcedure: getPresetSuggestionsForProcedure,
            hasActiveFilter: hasActiveFilter
        };

        /**
         * Get only suggestions with a property <tt>_selected</tt> evaluating to <tt>true</tt>.
         *
         * @memberof columnFilterService
         * @param {app.ColumnFilterDto[]} suggestions
         * @returns {app.ColumnFilterDto[]}
         */
        function filterSelectedSuggestions(suggestions) {
            return $filter('filter')(suggestions, { _selected: true });
        }

        /**
         * Check if a suggestion is contained in past selections.
         *
         * @memberof columnFilterService
         * @param {app.ColumnFilterDto[]} pastSelections
         * @param {app.ColumnFilterDto} suggestion
         * @returns {boolean}
         */
        function hasBeenSelectedInThePast(pastSelections, suggestion) {
            if (!pastSelections || !pastSelections.length) {
                return false;
            }

            for (var i = 0; i < pastSelections.length; i++) {
                if (pastSelections[i] === suggestion.value) {
                    return true;
                }
            }

            return false;
        }

        /**
         * Add flag <tt>_selected</tt> to the suggestions, if they have already been selected in the past.
         *
         * @memberof columnFilterService
         * @see {@link hasBeenSelectedInThePast}
         * @param {app.ColumnFilterDto[]} pastSelections
         * @param {app.ColumnFilterDto[]} suggestions
         * @returns {app.ColumnFilterDto[]}
         */
        function addSelectedFlags(pastSelections, suggestions) {
            for (var i = 0; i < suggestions.length; i++) {
                var suggestion = suggestions[i];
                suggestion._selected = hasBeenSelectedInThePast(
                    pastSelections,
                    suggestion
                );
            }
            return suggestions;
        }

        /**
         * Get the preset suggestions for preset column filters.
         *
         * @memberof columnFilterService
         * @params {app.COLUMN_FILTER#COL} filterColumn
         * @returns {boolean|null} <tt>null</tt> when it's not a column filter type supporting preset suggestions,
         *  otherwise the suggestions severed by the client and not requested from the server.
         */
        function getPresetSuggestions(filterColumn) {
            var presetColumnFilterIndex =
                presetColumnFilters.indexOf(filterColumn);
            if (presetColumnFilterIndex === -1) {
                return null;
            }

            return presetSuggestionsForColumnFilter[
                presetColumnFilters[presetColumnFilterIndex]
            ];
        }

        function hasActiveFilter(colFiltOpts: { string: any }): boolean {
            if (!colFiltOpts || angular.equals(colFiltOpts, {})) {
                return false;
            }

            for (let key in colFiltOpts) {
                if (!!colFiltOpts[key] && !!colFiltOpts[key].length) {
                    return true;
                }
            }

            return false;
        }

        function getPresetSuggestionsForCapacityCategory() {
            return presetSuggestionsForColumnFilter[
                COLUMN_FILTER.COL.CAPACITY_CATEGORY
            ];
        }

        function getPresetSuggestionsForDirection() {
            return presetSuggestionsForColumnFilter[
                COLUMN_FILTER.COL.DIRECTION
            ];
        }

        function getPresetSuggestionsForProcedure() {
            return presetSuggestionsForColumnFilter[
                COLUMN_FILTER.COL.PROCEDURE
            ];
        }
    }
})();
